import React, { FC } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { SHOPIFY_CDN_ASSET_LOADING_GIF } from '@/core/constants';

export interface Props {
  loading: boolean;
  text?: string;
  className?: string;
  loadingIconURL?: string;
}

export const Loader: FC<Props> = ({
  loading = false,
  text = `Loading`,
  className = ``,
  loadingIconURL = SHOPIFY_CDN_ASSET_LOADING_GIF,
}) => {
  if (!loading) {
    return null;
  }
  const s = {
    wrapper:
      'flex justify-center items-center flex-col w-[150px] container mx-auto',
    text: 'text-base text-left text-charcoal',
    image: 'w-full object-cover w-40',
  };

  return (
    <div className={classNames(s.wrapper, className)} data-testid="loading">
      <Image
        src={loadingIconURL}
        alt={text}
        width={100}
        height={100}
        className={s.image}
      />
      <p className={s.text}>{text}</p>
    </div>
  );
};

export default React.memo(Loader);
